export enum PreCheckinFormCustomizationActionTypes {
  IsFormCustomizationReady = '[IsFormCustomizationReady] action',
  GetCheckinFormFields = '[GetCheckinFormFields] action'
}

export class IsFormCustomizationReady {
  public static readonly type = PreCheckinFormCustomizationActionTypes.IsFormCustomizationReady;
  constructor(public payload: boolean) {}
}

export class GetCheckinFormFields {
  public static readonly type = PreCheckinFormCustomizationActionTypes.GetCheckinFormFields;
  constructor(public trainingCenterId: string) {}
}